<template>
  <div
    class="B2CAnchorLinks mobOnly:-mx-12
  flex flex-col desk:flex-row justify-start desk:justify-center items-start desk:items-center gap-8 desk:gap-16
  mb-48 desk:mb-96"
  >
    <div v-if="!uiStore.isMobile" class="grow h-1 bg-border-subtle" />
    <div class="mobOnly:layout-container type-sm text-text-subtle">{{ $t('anchorlink.headline') }}</div>
    <component :is="uiStore.isMobile ? SideScroll:'div'">
      <div class="flex gap-8 mobOnly:layout-container desk:justify-center desk:items-center">
        <button
          class="btn btn--outline btn--sm"
          @click="scrollToAnchor('ProductPersonality')"
        >
          {{ $t('anchorlink.personality') }}
        </button>
        <button
          v-if="existingAnchors.includes('ProductAccessories')"
          class="btn btn--outline btn--sm"
          @click="scrollToAnchor('ProductAccessories')"
        >
          {{ $t('anchorlink.recommendedAccessories') }}
        </button>
        <button
          v-if="existingAnchors.includes('MoodGallery')"
          class="btn btn--outline btn--sm"
          @click="scrollToAnchor('MoodGallery')"
        >
          {{ $t('anchorlink.colour') }}
        </button>
        <!--        <button
          class="btn btn&#45;&#45;outline btn&#45;&#45;sm"
          @click="scrollToAnchor('')"
        >
          {{ $t('anchorlink.material') }}
        </button>-->
        <button
          class="btn btn--outline btn--sm"
          @click="scrollToAnchor('pdpShowParametrics')"
        >
          {{ $t('anchorlink.facts') }}
        </button>
        <button
          v-if="existingAnchors.includes('ProductFiles')"
          class="btn btn--outline btn--sm"
          @click="scrollToAnchor('ProductFiles')"
        >
          {{ $t('anchorlink.documents') }}
        </button>
        <button
          v-if="existingAnchors.includes('AccordionBlock')"
          class="btn btn--outline btn--sm"
          @click="scrollToAnchor('AccordionBlock')"
        >
          {{ $t('anchorlink.faq') }}
        </button>
        <div class="w-16 desk:hidden">&nbsp;</div>
      </div>
    </component>

    <div v-if="!uiStore.isMobile" class="grow h-1 bg-border-subtle" />
  </div>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
import SideScroll from '~/components/globals/SideScroll.vue';

const uiStore = useUiStore();

const scrollToAnchor = (id: string) => {
  const element = document.getElementById(id);
  console.log(element);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY - 80;
    console.log(elementPosition);
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth',
    });
  }
};

/**
 * Some components only shows after mounted and if they have loaded any data
 * example, ProductFiles don't show if there are no files
 */
const existingAnchors = ref<string[]>([]);

onMounted(() => {
  checkAnchors();

  // we do a second check if some component loader really slow
  setTimeout(()=> checkAnchors(), 2500);
});

const checkAnchors = () => {
  const anchors = document.querySelectorAll('a[id]');
  anchors.forEach((anchor) => {
    const id = anchor.getAttribute('id');
    if (id && !existingAnchors.value.includes(id)) {
      existingAnchors.value.push(id);
    }
  });
};

</script>

<style scoped lang="postcss">
</style>
